import React from 'react';

import CheckboxFilter from 'bundles/backoffice/filters/checkbox';

import type { Filters } from './types';
import { FormLabel } from 'react-bootstrap-5';

export const options = [
  { label: 'Call', value: 'call' },
  { label: 'Meeting', value: 'meeting' },
  { label: 'Tour', value: 'showing' },
  { label: 'Note', value: 'note' },
  { label: 'Email', value: 'message' },
];

type Slice = Pick<Filters, 'activityTypes'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

export default function ActivityTypeFilter({ activityTypes, onChange }: Props) {
  const getInputText = () => {
    const selected = activityTypes?.map((type) => {
      const matchType = options.find(opt => opt.value === type);
      return matchType?.label || '';
    }) || [];

    if (selected.length === options.length || selected.length === 0) {
      return 'All Types';
    } else if (selected.length === 1) {
      return selected[0];
    } else if (selected.length > 1) {
      return `${selected[0]}, +${selected.length - 1}`;
    }
  };

  return (
    <div className="flex-grow-1">
      <FormLabel>Type</FormLabel>
      <CheckboxFilter
        addFilter={(_name, filter) => onChange({ activityTypes: [...(activityTypes), filter] })}
        className="text-truncate"
        hideSelectedCount={!activityTypes?.length}
        label={getInputText()}
        options={options}
        removeFilter={(_name, filter) => onChange({ activityTypes: (activityTypes).filter(t => t !== filter) })}
        selected={activityTypes}
      />
    </div>
  );
}
